import React from 'react'
import clsx from 'clsx'
import { Calendar1 } from 'iconsax-react'
import { formatDateRelative } from '@SonarCX/utilities'
import { useTheme } from '@mui/material'

const CreatedSection = ({ classes, values }) => {
  const theme = useTheme()
  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        classes.container
      )}
      style={{ cursor: 'default' }}
    >
      <span className={clsx(classes.center, classes.label)}>
        <Calendar1
          size={theme.size.base}
          variant='Bulk'
          color={theme.palette.primary.main}
        />{' '}
        CREATED
      </span>

      <div>{formatDateRelative(values?.created_at, true)}</div>
    </div>
  )
}

export default CreatedSection
